import React, {useEffect, useState} from "react";
import {Field} from "formik";
import {Boolean, Input, RadioGroup, ReactDropZone, ReactSelect} from "../../../../../../_intesys/_partials/controls";
import {injectIntl} from "react-intl";
import {shallowEqual, useSelector} from "react-redux";
import {documentTypeGetFieldDefault, documentTypeHasField, filterUsersByPermissions, getDocumentLabelFromType, getDocumentSigTypeIntlIdFromValue, getDocumentTypeExtraFields, getDocumentTypesFilteredByFolderType, getUserLabel,} from "../../../../../../_intesys/_helpers";
import {SIG_TYPES} from "../DocumentsUIHelper";
import {fetchCoworkers} from "../../../_redux/coworkers/coworkersActions";
import {fixUserDataForApp} from "../../../../Admin/_redux/users/usersActions";

function DocumentEditDialogFormFields({
                                          isEdit = false,
                                          folderType,
                                          folderBrand,
                                          documentType,
                                          namePrefix = "",
                                          isWizard = false,
                                          intl,
                                          setFieldValue
                                      }) {

    const {user, dealers, folderTypesExt} = useSelector(
        (state) => ({
            user: state.auth.user,
            dealers: state.dealers.dealers,
            folderTypesExt: state.configurations.folderTypesExt,
        }),
        shallowEqual
    );

    const [hasSalesManagers, setHasSalesManagers] = useState(false);
    const [hasOperatorDealers, setHasOperatorDealers] = useState(false);

    const [salesManagers, setSalesManagers] = useState([]);
    const [operatorDealers, setOperatorDealers] = useState([]);

    const [filteredSalesManagers, setFilteredSalesManagers] = useState([]);
    const [filteredOperatorDealers, setFilteredOperatorDealers] = useState([]);

    const [documentTypeExtraFields, setDocumentTypeExtraFields] = useState([]);

    useEffect(() => {
        if (hasSalesManagers) {
            fetchCoworkers("ROLE_SALE_MANAGER").then(res => {
                const coworkers = res.map((user) => fixUserDataForApp(user));
                setSalesManagers(coworkers);
            });
        }
    }, [hasSalesManagers]);

    useEffect(() => {

        if (hasOperatorDealers) {
            fetchCoworkers("ROLE_OPERATOR_DEALER").then(res => {
                const coworkers = res.map((user) => fixUserDataForApp(user));
                setOperatorDealers(coworkers);
            });
        }
    }, [hasOperatorDealers]);

    useEffect(() => {
        documentTypeExtraFields.forEach((field) => {
            const fieldType = field.type;
            if (fieldType === 'ROLE_OPERATOR_DEALER') {
                setHasOperatorDealers(true);
            }
            if (fieldType === 'ROLE_SALE_MANAGER') {
                setHasSalesManagers(true);
            }
        })
    }, [documentTypeExtraFields]);

    useEffect(() => {
        setDocumentTypeExtraFields(getDocumentTypeExtraFields(documentType, folderType, folderTypesExt, dealers, user));
    }, [documentType, folderType, folderTypesExt, dealers, user]);


    useEffect(() => {
        //TODO: add hst filter
        setFilteredSalesManagers(filterUsersByPermissions(folderBrand, folderType, salesManagers));
    }, [salesManagers, folderType, folderBrand])

    useEffect(() => {
        //TODO: add hst filter
        setFilteredOperatorDealers(filterUsersByPermissions(folderBrand, folderType, operatorDealers));
    }, [operatorDealers, folderType, folderBrand])

    function renderExtraField(field) {
        let result;
        const fieldName = field.field;

        const inputName = `${namePrefix}variableFields_${fieldName}`;
        const inputLabel = field.label;
        const fieldType = field.type;
        //let fieldType = getExtraFieldType(fieldName);//TODO: change


        switch (fieldType) {
            case 'string':

                result =
                    <div className="col-md-6" key={fieldName}>
                        <Field
                            name={inputName}
                            component={Input}
                            label={inputLabel}
                            // placeholder={intl.formatMessage({id: "FOLDERS.FIELDS." + field.field.toUpperCase() + ".PLACEHOLDER"})}
                            // initialFeedBackLabel={intl.formatMessage({id: "FOLDERS.FIELDS." + field.field.toUpperCase() + ".FEEDBACK"})}
                        />
                    </div>;
                break;
            case 'checkbox':
                result =
                    <div className="col-md-12" key={fieldName}>
                        <Field
                            name={inputName}
                            component={Boolean}
                            type={"checkbox"}
                            label={inputLabel}
                            // label={intl.formatMessage({id: "USERS.FIELDS.ACTIVATED.LABEL"})}
                            // checkBoxLabel={intl.formatMessage({id: "USERS.FIELDS.ACTIVATED.PLACEHOLDER"})}
                            // placeholder={intl.formatMessage({id: "USERS.FIELDS.ACTIVATED.PLACEHOLDER"})}
                            // initialFeedBackLabel={intl.formatMessage({id: "USERS.FIELDS.ACTIVATED.FEEDBACK"})}
                        />
                    </div>;

                break;
            case 'date':
                result =
                    <div className="col-lg-6" key={fieldName}>
                        <Field
                            name={inputName}
                            component={Input}
                            type={"date"}
                            label={inputLabel}
                            placeholder={inputLabel}
                            initialFeedBackLabel={inputLabel}
                            // label={intl.formatMessage({id: "SERVICES.FIELDS.EXPIRESAT.LABEL"})}
                            // placeholder={intl.formatMessage({id: "SERVICES.FIELDS.EXPIRESAT.PLACEHOLDER"})}
                            // initialFeedBackLabel={intl.formatMessage({id: "SERVICES.FIELDS.EXPIRESAT.FEEDBACK"})}
                        />
                    </div>;
                break;
            case 'ROLE_OPERATOR_DEALER':
            case 'ROLE_SALE_MANAGER':
                let selectOptions = [];
                if (fieldType === 'ROLE_SALE_MANAGER') {
                    selectOptions = filteredSalesManagers;
                } else if (fieldType === 'ROLE_OPERATOR_DEALER') {
                    selectOptions = filteredOperatorDealers;
                }

                result =
                    <div className="col-lg-6" key={fieldName}>

                        <Field
                            isClearable
                            id={`${inputName}`}
                            name={inputName}
                            component={ReactSelect}
                            label={inputLabel}
                            // placeholder={inputLabel}
                            // initialFeedBackLabel={inputLabel}
                            options={selectOptions}
                            getOptionLabel={opt => getUserLabel(opt)}
                            getOptionValue={opt => opt.id}


                            onChangeFunction={
                                (selectedOption) => {
                                    let filteredValue = "";
                                    if (selectedOption) {
                                        filteredValue = selectedOption.id;
                                    }
                                    return filteredValue;
                                }
                            }

                            valueFunction={
                                (options, field) => {
                                    if (!options) {
                                        return undefined;
                                    }
                                    if (field.value) {
                                        return options.find((user) => user.id === field.value);
                                    }
                                    return undefined;
                                }
                            }
                        />

                    </div>;
                break;
            default:
                result =
                    <div className="col-md-12" key={fieldName}>
                        <div className={"text-danger"}>
                            {field.field} non gestito
                        </div>
                    </div>;
        }
        return result;
    }

    return (
        <>
            <div className="form-group row">
                {(!isEdit && !isWizard) &&
                    <div className="col-md-12">
                        <Field
                            name={`${namePrefix}type`}
                            component={ReactSelect}
                            label={intl.formatMessage({id: "DOCUMENTS.FIELDS.TYPE.LABEL"})}
                            placeholder={intl.formatMessage({id: "DOCUMENTS.FIELDS.TYPE.PLACEHOLDER"})}
                            initialFeedBackLabel={intl.formatMessage({id: "DOCUMENTS.FIELDS.TYPE.FEEDBACK"})}
                            options={getDocumentTypesFilteredByFolderType(folderType, folderTypesExt, dealers, user, false).map((documentTypeZZ) => {
                                return {
                                    label: getDocumentLabelFromType(documentTypeZZ, folderType, folderTypesExt, dealers, user),
                                    value: documentTypeZZ,
                                };
                            })}

                            getOptionLabel={opt => getDocumentLabelFromType(opt.value, folderType, folderTypesExt, dealers, user)}
                            getOptionValue={opt => opt.value}

                            onChangeFunction={
                                (selectedOption) => {
                                    if (!isEdit) {

                                        const baseFields = [
                                            {
                                                'name': 'sigType',
                                                'field': 'SIG_TYPE',
                                                'type': 'string'
                                            },
                                            {
                                                'name': 'signable',
                                                'field': 'SIGNABLE',
                                                'type': 'boolean'
                                            },
                                            {
                                                'name': 'archivable',
                                                'field': 'ARCHIVABLE',
                                                'type': 'boolean'
                                            }
                                        ]

                                        baseFields.forEach((baseField) => {
                                            let defaultValue = documentTypeGetFieldDefault(selectedOption.value, folderType, folderTypesExt, baseField.field, dealers, user, baseField.type);
                                            if (defaultValue !== null) {
                                                setFieldValue(namePrefix + baseField.name, defaultValue);
                                            }
                                        });


                                        const documentTypeExtraFields = getDocumentTypeExtraFields(selectedOption.value, folderType, folderTypesExt, dealers, user);
                                        documentTypeExtraFields.forEach((documentTypeExtraField) => {
                                            let defaultValue = documentTypeGetFieldDefault(selectedOption.value, folderType, folderTypesExt, documentTypeExtraField.field, dealers, user, documentTypeExtraField.type);
                                            if (defaultValue !== null) {
                                                const fieldName = documentTypeExtraField.field;
                                                const inputName = `${namePrefix}variableFields_${fieldName}`;
                                                setFieldValue(inputName, defaultValue);
                                            }
                                        });

                                    }

                                    let filteredValue = undefined;
                                    if (selectedOption) {
                                        filteredValue = selectedOption.value;
                                    }
                                    return filteredValue;
                                }
                            }
                            valueFunction={
                                (options, field) => {
                                    if (!options) {
                                        return undefined;
                                    }
                                    if (field.value) {
                                        return options.find((dealer) => dealer.value === field.value);
                                    }
                                    return undefined;
                                }
                            }
                        />

                    </div>

                }

                {(!isEdit && documentTypeHasField(documentType, folderType, folderTypesExt, "FILE", dealers, user)) &&

                    <div className="col-md-12">
                        <Field
                            name={`${namePrefix}file`}
                            maxFiles={1}
                            // accept={[
                            //     "application/pdf",//pdf
                            //     "image/jpeg",//jpeg
                            //     "image/png",//png
                            //     "image/tiff",//tiff
                            //     "application/msword",//doc
                            //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document"//docx
                            // ].join(", ")}
                            component={ReactDropZone}
                            multiple={false}
                            label={intl.formatMessage({id: "DOCUMENTS.FIELDS.FILE.LABEL"})}
                            placeholder={intl.formatMessage({id: "DOCUMENTS.FIELDS.FILE.PLACEHOLDER"})}
                            initialFeedBackLabel={intl.formatMessage({id: "DOCUMENTS.FIELDS.FILE.FEEDBACK"})}
                        />

                    </div>

                }

                {documentTypeHasField(documentType, folderType, folderTypesExt, "SIG_TYPE", dealers, user) && (

                    <div className="col-md-12">
                        <RadioGroup
                            name={`${namePrefix}sigType`}
                            label={intl.formatMessage({id: "DOCUMENTS.FIELDS.SIGTYPE.LABEL"}, {
                                strong: chunks => (
                                    <strong>{chunks}</strong>
                                )
                            })}
                            placeholder={intl.formatMessage({id: "DOCUMENTS.FIELDS.SIGTYPE.PLACEHOLDER"})}
                            initialFeedBackLabel={intl.formatMessage({id: "DOCUMENTS.FIELDS.SIGTYPE.FEEDBACK"})}
                            options={SIG_TYPES.map((signatureType) => {
                                return {
                                    value: signatureType,
                                    label: intl.formatMessage({id: getDocumentSigTypeIntlIdFromValue(signatureType)})
                                }
                            })}
                        />
                    </div>

                )}

                {documentTypeHasField(documentType, folderType, folderTypesExt, "SIGNABLE", dealers, user) && (
                    <div className="col-md-12">
                        <Field
                            name={`${namePrefix}signable`}
                            component={Boolean}
                            type={"checkbox"}
                            label={intl.formatMessage({id: "DOCUMENTS.FIELDS.SIGNABLE.LABEL"})}
                            checkBoxLabel={intl.formatMessage({id: "DOCUMENTS.FIELDS.SIGNABLE.CHECKBOX_LABEL_WITH_STRONG"}, {
                                strong: chunks => (
                                    <strong>{chunks}</strong>
                                )
                            })}
                            initialFeedBackLabel={intl.formatMessage({id: "DOCUMENTS.FIELDS.SIGNABLE.FEEDBACK"})}
                            helpText={intl.formatMessage({id: "DOCUMENTS.FIELDS.SIGNABLE.HELP"})}
                        />
                    </div>
                )}

                {documentTypeHasField(documentType, folderType, folderTypesExt, "ARCHIVABLE", dealers, user) && (

                    <div className="col-md-12">
                        <Field
                            name={`${namePrefix}archivable`}
                            component={Boolean}
                            type={"checkbox"}
                            label={intl.formatMessage({id: "DOCUMENTS.FIELDS.ARCHIVABLE.LABEL"})}
                            checkBoxLabel={intl.formatMessage({id: "DOCUMENTS.FIELDS.ARCHIVABLE.CHECKBOX_LABEL_WITH_STRONG"}, {
                                strong: chunks => (
                                    <strong>{chunks}</strong>
                                )
                            })}
                            initialFeedBackLabel={intl.formatMessage({id: "DOCUMENTS.FIELDS.ARCHIVABLE.FEEDBACK"})}
                        />
                    </div>

                )}

                {documentTypeExtraFields.map((field) => renderExtraField(field))}


            </div>


        </>
    );

}


export default injectIntl(DocumentEditDialogFormFields);
